import React, { useState, useEffect } from 'react';
import { connect, useDispatch } from 'react-redux';
import {
  Button,
  Avatar,
  Box,
  Menu,
  List,
  ListItem,
  Divider,
  Badge,
  TextField,
  Collapse,
  Typography,
  Grid,
} from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import { setUserAuthenticated, setUserClearanceLevel } from 'reducers/UserReducer';
import {
  openSettings,
  showAboutDialog,
  showReleaseNotesDialog,
  showChangePasswordDialog,
} from 'reducers/DialogsReducer';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { authorizeExternalApp } from 'reducers/UserReducer';
import { resetUserSettings, saveUserSetting } from 'reducers/UserSettingsReducer';
import { setMode } from 'reducers/ThemeReducer';
import Checkbox2 from 'components/Checkbox2';
import { Autocomplete } from '@material-ui/lab';
import {
  ListItemButton,
  ListItemText,
  Switch,
  ListItemIcon,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from '@mui/material';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import AppsIcon from '@mui/icons-material/Apps';
import TuneIcon from '@mui/icons-material/Tune';
import KeyIcon from '@mui/icons-material/Key';
import SchoolIcon from '@mui/icons-material/School';
import RestartAltIcon from '@mui/icons-material/RestartAlt';
import HeadsetMicIcon from '@mui/icons-material/HeadsetMic';

import DeleteSweepIcon from '@mui/icons-material/DeleteSweep';
import SettingsBackupRestoreIcon from '@mui/icons-material/SettingsBackupRestore';
import InfoIcon from '@mui/icons-material/Info';
import NewReleasesIcon from '@mui/icons-material/NewReleases';
import AddCallIcon from '@mui/icons-material/AddIcCall';
import SignalCellularAltIcon from '@mui/icons-material/SignalCellularAlt';

import WbSunnyIcon from '@mui/icons-material/WbSunny';
import DarkModeIcon from '@mui/icons-material/DarkMode';
import { getService } from 'reducers/service';
import { getAccessPermission, getAgenciesAccessPermission } from '../reducers/PermissionsReducer';
import store from '../config/configureStore';
import { getServerTimeSettings } from 'reducers/TimeReducer';
import { getDictionaries } from 'reducers/DictionaryReducer';
import { getUserPermissions } from '../reducers/PermissionsReducer';
import { notify } from 'reducers/NotifierReducer';
import IconRms from '../assets/images/icon-RMS.svg';
import IconAms from '../assets/images/icon-AMS.svg';
import IconMobile from '../assets/images/icon-MOBILE.svg';
import IconAnalytics from '../assets/images/icon-ANALYTICS.png';
import IconArchive from '../assets/images/icon-ARC.png';
import IconSetting from '../assets/images/icon-SETTING.png';
import {
  getAttachmentSizeLimit,
  getPasswordValidation,
  getSessionSettings,
} from 'reducers/ConfigReducer';

// function getSettingsUrl() {
//   let url = process.env.REACT_APP_SETTINGS_URL;
//   if (!url) return '';
//   if (url.substr(-1) !== '/') url += '/';
//   url += 'resources';
//   return url;
// }

//const settingsUrl = getSettingsUrl();

const UserBadge = withStyles({
  badge: {
    '&::after': {
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      borderRadius: '50%',
      animation: '$ripple 1.2s infinite ease-in-out',
      border: '1px solid currentColor',
      content: '""',
    },
  },
  '@keyframes ripple': {
    '0%': {
      transform: 'scale(.8)',
      opacity: 1,
    },
    '100%': {
      transform: 'scale(2.4)',
      opacity: 0,
    },
  },
})(Badge);

function UserMenu(props) {
  const {
    anchorEl,
    onClose,
    network,
    themeMode,
    setUserAuthenticated,
    user,
    serverConnection,
    setMode,
    enableE911,
    userCurrentClearanceLevel,
    userClearanceOptions,
    setUserClearanceLevel,
  } = props;
  const userName = user?.userData?.user?.Username || '';
  const [openAppSubmenu, setOpenAppSubmenu] = useState(false);
  const [openOptionSubmenu, setOpenOptionSubmenu] = useState(false);
  const [openCacheClearConfirmation, setOpenCacheClearConfirmation] = useState(false);
  const [openResetUserSettingsConfirmation, setOpenResetUserSettingsConfirmation] = useState(false);

  const isPermissionLoaded = store.store.getState().permissions.loaded;

  const settingPermission =
    isPermissionLoaded &&
    (getAccessPermission('modules', 'Settings') ||
      Boolean(getAgenciesAccessPermission('modules', 'Settings').length));

  const analyticsPermission = getAccessPermission('modules', 'Analytics', 'any');
  const archivePermission = getAccessPermission('modules', 'Incident Archive', 'any');

  const mobilePermission = isPermissionLoaded && getAccessPermission('modules', 'Mobile');

  const rmsPermission = isPermissionLoaded && getAccessPermission('modules', 'RMS');
  const amsPermission = isPermissionLoaded && getAccessPermission('modules', 'AMS');

  const [helpLink, setHelpLink] = useState(null);
  const [trainingLink, setTrainingLink] = useState(null);
  const [rmsLink, setRMSLink] = useState(null);
  const [amsLink, setAmsLink] = useState(null);
  const [mobileLink, setMobileLink] = useState(null);
  const [analyticsLink, setAnalyticsLink] = useState(null);
  const [settingLink, setSettingLink] = useState(null);
  const [archiveLink, setArchiveLink] = useState(null);

  const dispatch = useDispatch();

  useEffect(() => {
    getHelpUrl();
    getTrainingUrl();
    getRMSUrl();
    getSettingUrl();
    getMobileUrl();
    getAnalyticsUrl();
    getArchiveUrl();
    getAmsUrl();
  }, []);

  const handleAppClick = () => {
    setOpenAppSubmenu((prev) => !prev);
  };

  const handleOptionClick = () => {
    setOpenOptionSubmenu((prev) => !prev);
  };

  const getHelpUrl = async () => {
    const service = getService('cdr');

    const data = await service.get({
      Path: 'Settings.Link.Help',
      CDRKey: 'HelpLink',
    });

    if (data && data.length > 0) setHelpLink(data[0].ValueString || '');
  };

  const getTrainingUrl = async () => {
    const service = getService('cdr');

    const data = await service.get({
      Path: 'Settings.Link.Training',
      CDRKey: 'TrainingLink',
    });

    if (data && data.length > 0) setTrainingLink(data[0].ValueString || '');
  };

  const getRMSUrl = async () => {
    const service = getService('cdr');

    const data = await service.get({
      Path: 'Settings.Link.RMS',
      CDRKey: 'RMSLink',
    });

    if (data && data.length > 0) setRMSLink(data[0].ValueString || '');
  };

  const getMobileUrl = async () => {
    const service = getService('cdr');

    const data = await service.get({
      Path: 'Settings.Link.Mobile',
      CDRKey: 'MobileLink',
    });

    if (data && data.length > 0) setMobileLink(data[0].ValueString || '');
  };

  const getAnalyticsUrl = async () => {
    const service = getService('cdr');

    const data = await service.get({
      Path: 'Settings.Link.Analytics',
      CDRKey: 'AnalyticsLink',
    });

    if (data && data.length > 0) setAnalyticsLink(data[0].ValueString || '');
  };

  const getSettingUrl = async () => {
    const service = getService('cdr');

    const data = await service.get({
      Path: 'Settings.Link.Setting',
      CDRKey: 'SettingLink',
    });

    if (data && data.length > 0) setSettingLink(data[0].ValueString || '');
  };

  const getAmsUrl = async () => {
    const service = getService('cdr');

    const data = await service.get({
      Path: 'Settings.Link.AMS',
      CDRKey: 'AMSLink',
    });

    if (data && data.length > 0) setAmsLink(data[0].ValueString || '');
  };

  const handleClearCache = () => {
    setOpenCacheClearConfirmation(true);
  };

  const handleResetUserSettings = () => {
    setOpenResetUserSettingsConfirmation(true);
  };

  const getArchiveUrl = async () => {
    const service = getService('cdr');

    const data = await service.get({
      Path: 'Settings.Link.Archive',
      CDRKey: 'ArchiveLink',
    });

    if (data && data.length > 0) setArchiveLink(data[0].ValueString || '');
  };

  const handleConfirmationClick = () => {
    const auth = localStorage.getItem('auth');
    localStorage.clear();
    sessionStorage.clear();
    localStorage.setItem('auth', auth);
    //history.push('/');
    window.location.reload();
  };
  const handleResetConfirmationClick = () => {
    dispatch(resetUserSettings());
    setOpenResetUserSettingsConfirmation(false);
    handleCloseDialog();
    onClose();
  };

  const handleCloseDialog = () => {
    setOpenCacheClearConfirmation(false);
    setOpenResetUserSettingsConfirmation(false);
  };

  const showReleaseNotesDialog = () => {
    props.showReleaseNotesDialog();
    onClose();
  };

  const showChangePasswordDialog = () => {
    props.showChangePasswordDialog();
    onClose();
  };

  const reloadLookupCodesAndPermissions = () => {
    dispatch(getServerTimeSettings());
    dispatch(getDictionaries());
    dispatch(getUserPermissions());
    dispatch(getAttachmentSizeLimit());
    dispatch(getPasswordValidation());
    dispatch(getSessionSettings());
    onClose();
    dispatch(notify('Code and Permissions reloaded successfully', 'success'));
  };
  const StyledBadge = withStyles({
    badge: {
      backgroundColor: serverConnection === false ? 'var(--danger)' : 'var(--success)',
      color: serverConnection === false ? 'var(--danger)' : 'var(--success)',
    },
  })(UserBadge);

  const toggleColorMode = () => {
    const newMode = themeMode === 'night' ? 'day' : 'night';
    setMode();
    props.saveUserSetting('themeMode', newMode);
    setMode(newMode);
  };

  const showAboutDialog = () => {
    props.showAboutDialog();
    onClose();
  };

  const handleOpenOptions = () => {
    props.openSettings();
    onClose();
  };

  const handleOpenSettings = () => {
    authorizeExternalApp();
    onClose();
  };

  const handleEnableE911 = (val) => {
    if (enableE911 !== val) props.saveUserSetting('enableE911', val);
  };
  const handleChangeUserClearance = (ev, val) => {
    setUserClearanceLevel(val);
  };

  return (
    <Menu
      anchorEl={anchorEl}
      keepMounted
      getContentAnchorEl={null}
      open={Boolean(anchorEl)}
      anchorOrigin={{ vertical: 'center', horizontal: 'center' }}
      transformOrigin={{ vertical: 'center', horizontal: 'center' }}
      onClose={onClose}
      className="ml-2">
      <div className="dropdown-menu-right dropdown-menu-xxl overflow-hidden p-0">
        <List className="text-left bg-transparent flex-column pt-0">
          <Box className="text-center">
            <StyledBadge
              overlap="circle"
              anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
              variant="dot">
              <Avatar sizes="44" alt={userName} />
            </StyledBadge>
          </Box>
          <div>
            <div className="font-weight-bold text-center pt-2 line-height-1">{userName}</div>
          </div>
          <Divider className="w-100 mt-2" />
          <ListItem>
            <ListItemIcon>{themeMode !== 'day' ? <WbSunnyIcon /> : <DarkModeIcon />}</ListItemIcon>
            <ListItemText primary={themeMode !== 'day' ? 'Light Mode' : 'Dark Mode'} />
            <Switch checked={themeMode !== 'day'} onChange={toggleColorMode} />
          </ListItem>
          {(settingPermission ||
            mobilePermission ||
            analyticsPermission ||
            rmsPermission ||
            archivePermission ||
            amsPermission) && (
            <>
              <ListItemButton button onClick={handleAppClick}>
                <ListItemIcon>
                  <AppsIcon />
                </ListItemIcon>
                <ListItemText primary="My Applications" />
                {openAppSubmenu ? <ExpandLess /> : <ExpandMore />}
              </ListItemButton>
              <Collapse in={openAppSubmenu} timeout="auto" unmountOnExit>
                <List component="div" disablePadding>
                  {rmsPermission && (
                    <ListItemButton
                      sx={{ pl: 5 }}
                      onClick={handleOpenSettings}
                      button
                      component="a"
                      href={rmsLink}
                      target="_settings"
                      disabled={!rmsLink}>
                      <ListItemIcon>
                        <img src={IconRms} alt="RMS icon" style={{ width: 24, height: 24 }} />
                      </ListItemIcon>
                      <ListItemText primary="RMS" />
                    </ListItemButton>
                  )}
                  {mobilePermission && (
                    <ListItemButton
                      sx={{ pl: 5 }}
                      onClick={handleOpenSettings}
                      button
                      component="a"
                      href={mobileLink}
                      target="_settings"
                      disabled={!mobileLink}>
                      <ListItemIcon>
                        <img src={IconMobile} alt="MOBILE icon" style={{ width: 24, height: 24 }} />
                      </ListItemIcon>
                      <ListItemText primary="Mobile" />
                    </ListItemButton>
                  )}
                  {analyticsPermission && (
                    <ListItemButton
                      sx={{ pl: 5 }}
                      onClick={handleOpenSettings}
                      button
                      component="a"
                      href={analyticsLink}
                      target="_settings"
                      disabled={!analyticsLink}>
                      <ListItemIcon>
                        <img
                          src={IconAnalytics}
                          alt="Analytics icon"
                          style={{ width: 24, height: 24 }}
                        />
                      </ListItemIcon>
                      <ListItemText primary="Analytics" />
                    </ListItemButton>
                  )}
                  {archivePermission && (
                    <ListItemButton
                      sx={{ pl: 5 }}
                      onClick={handleOpenSettings}
                      button
                      component="a"
                      href={archiveLink}
                      target="_settings"
                      disabled={!archiveLink}>
                      <ListItemIcon>
                        <img
                          src={IconArchive}
                          alt="Archive icon"
                          style={{ width: 24, height: 24 }}
                        />
                      </ListItemIcon>
                      <ListItemText primary="Archive Browser" />
                    </ListItemButton>
                  )}
                  {settingPermission && (
                    <ListItemButton
                      sx={{ pl: 5 }}
                      onClick={handleOpenSettings}
                      button
                      component="a"
                      href={settingLink}
                      target="_settings"
                      disabled={!settingLink}>
                      <ListItemIcon>
                        <img
                          src={IconSetting}
                          alt="Setting icon"
                          style={{ width: 24, height: 24 }}
                        />
                      </ListItemIcon>
                      <ListItemText primary="Setting" />
                    </ListItemButton>
                  )}
                  {amsPermission && (
                    <ListItemButton
                      sx={{ pl: 5 }}
                      onClick={handleOpenSettings}
                      button
                      component="a"
                      href={amsLink}
                      target="_settings"
                      disabled={!amsLink}>
                      <ListItemIcon>
                        <img src={IconAms} alt="AMS icon" style={{ width: 24, height: 24 }} />
                      </ListItemIcon>
                      <ListItemText primary="AMS" />
                    </ListItemButton>
                  )}
                </List>
              </Collapse>
            </>
          )}
          <ListItemButton button onClick={handleOptionClick}>
            <ListItemIcon>
              <TuneIcon />
            </ListItemIcon>
            <ListItemText primary="Options" />
            {openOptionSubmenu ? <ExpandLess /> : <ExpandMore />}
          </ListItemButton>
          <Collapse in={openOptionSubmenu} timeout="auto" unmountOnExit>
            <List component="div" disablePadding>
              <ListItemButton sx={{ pl: 5 }} onClick={() => showChangePasswordDialog()} button>
                <ListItemIcon>
                  <KeyIcon />
                </ListItemIcon>
                <ListItemText primary="Change Password" />
              </ListItemButton>

              <ListItemButton sx={{ pl: 5 }} onClick={reloadLookupCodesAndPermissions} button>
                <ListItemIcon>
                  <RestartAltIcon />
                </ListItemIcon>
                <ListItemText primary="Reload Codes & Permissions" />
              </ListItemButton>
              <ListItemButton sx={{ pl: 5 }} onClick={handleClearCache} button>
                <ListItemIcon>
                  <DeleteSweepIcon />
                </ListItemIcon>
                <ListItemText primary="Clear Cache" />
              </ListItemButton>

              <ListItemButton sx={{ pl: 5 }} onClick={handleResetUserSettings} button>
                <ListItemIcon>
                  <SettingsBackupRestoreIcon />
                </ListItemIcon>
                <ListItemText primary="Reset User Settings" />
              </ListItemButton>

              <ListItemButton sx={{ pl: 5 }} onClick={() => handleOpenOptions()} button>
                <ListItemIcon>
                  <ManageAccountsIcon />
                </ListItemIcon>
                <ListItemText primary="User Preference" />
              </ListItemButton>
              <ListItemButton sx={{ pl: 5 }} style={{ marginBottom: -16 }}>
                <ListItemIcon>
                  <AddCallIcon />
                </ListItemIcon>
                <ListItemText primary="Enable 911 popup" />
                <Checkbox2 checked={enableE911} onChange={(ev, val) => handleEnableE911(val)} />
              </ListItemButton>
              <ListItem style={{ marginTop: 16, paddingLeft: 40 }}>
                <ListItemIcon>
                  <SignalCellularAltIcon />
                </ListItemIcon>
                <Autocomplete
                  id="clearance-level"
                  value={userCurrentClearanceLevel}
                  options={userClearanceOptions}
                  onChange={handleChangeUserClearance}
                  style={{ width: 210 }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Clearance Level"
                      variant="outlined"
                      size="small"
                    />
                  )}
                  getOptionSelected={(option, value) =>
                    option.ptsClearanceLevelID === value.ptsClearanceLevelID
                  }
                  getOptionLabel={(option) => option.Description}
                  renderOption={(option) => (
                    <span>{`${option.Level} - ${option.Description}`}</span>
                  )}
                />
              </ListItem>
            </List>
          </Collapse>

          <ListItemButton
            onClick={handleOpenSettings}
            button
            component="a"
            href={trainingLink}
            target="_settings"
            disabled={!trainingLink}>
            <ListItemIcon>
              <SchoolIcon />
            </ListItemIcon>
            <ListItemText primary="Training Academy" />
          </ListItemButton>
          <ListItemButton
            onClick={handleOpenSettings}
            button
            component="a"
            href={helpLink}
            target="_settings"
            disabled={!helpLink}>
            <ListItemIcon>
              <HeadsetMicIcon />
            </ListItemIcon>
            <ListItemText primary="Contact Support" />
          </ListItemButton>

          <ListItemButton button onClick={() => showReleaseNotesDialog()}>
            <ListItemIcon>
              <NewReleasesIcon />
            </ListItemIcon>
            <ListItemText primary="Release Notes" />
          </ListItemButton>

          <ListItemButton button onClick={() => showAboutDialog()}>
            <ListItemIcon>
              <InfoIcon />
            </ListItemIcon>
            <ListItemText primary="About" />
          </ListItemButton>

          <Divider className="w-100 mt-2" />

          <ListItem className="d-block rounded-bottom px-3 pt-3 pb-0 text-center">
            <Button
              onClick={() => setUserAuthenticated(false)}
              variant="outlined"
              size="medium"
              color="default">
              <span className="btn-wrapper--icon">
                <FontAwesomeIcon icon={['fas', 'sign-out-alt']} />
              </span>
              <span className="btn-wrapper--label">Logout</span>
            </Button>
          </ListItem>
        </List>
        <Dialog open={openCacheClearConfirmation} onClose={handleCloseDialog} maxWidth="md">
          <DialogTitle style={{ background: '#2871cc', color: 'white' }}>
            {<Typography variant="h5">Confirmation!</Typography>}
          </DialogTitle>
          <DialogContent style={{ display: 'flex', alignItems: 'center' }}>
            <Grid container>
              <Grid item xs={12}>
                <Typography
                  variant="subtitle2"
                  gutterBottom
                  component="div"
                  style={{ marginTop: 10 }}>
                  Clearing the cache will log you out of the system. You will lose all unsaved
                  progress. . Do you wish to proceed?
                </Typography>
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions>
            <div className="mb-1">
              <Button
                onClick={handleConfirmationClick}
                style={{ background: '#2871cc', color: '#fff', width: '80px', marginRight: '5px' }}>
                Yes
              </Button>
              <Button
                onClick={handleCloseDialog}
                style={{ background: '#2871cc', color: '#fff', width: '80px' }}>
                No
              </Button>
            </div>
          </DialogActions>
        </Dialog>

        <Dialog open={openResetUserSettingsConfirmation} onClose={handleCloseDialog} maxWidth="md">
          <DialogTitle style={{ background: '#2871cc', color: 'white' }}>
            {<Typography variant="h5">Confirmation!</Typography>}
          </DialogTitle>
          <DialogContent style={{ display: 'flex', alignItems: 'center' }}>
            <Grid container>
              <Grid item xs={12}>
                <Typography
                  variant="subtitle2"
                  gutterBottom
                  component="div"
                  style={{ marginTop: 10 }}>
                  Resetting user settings will clear your filters, layouts, and preferences, and restore defaults. Do you want to continue?
                </Typography>
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions>
            <div className="mb-1">
              <Button
                onClick={handleResetConfirmationClick}
                style={{ background: '#2871cc', color: '#fff', width: '80px', marginRight: '5px' }}>
                Yes
              </Button>
              <Button
                onClick={handleCloseDialog}
                style={{ background: '#2871cc', color: '#fff', width: '80px' }}>
                No
              </Button>
            </div>
          </DialogActions>
        </Dialog>
      </div>
    </Menu>
  );
}

const mapStateToProps = (state) => ({
  network: state.offline,
  themeMode: state.userSettings.themeMode,
  serverConnection: state.serverConnection,
  enableE911: state.userSettings.enableE911,
  userCurrentClearanceLevel: state.user.userCurrentClearanceLevel,
  userClearanceOptions: state.user.userClearanceOptions,
});

export default connect(mapStateToProps, {
  setUserAuthenticated,
  showAboutDialog,
  showReleaseNotesDialog,
  showChangePasswordDialog,
  openSettings,
  saveUserSetting,
  setMode,
  setUserClearanceLevel,
  notify,
})(UserMenu);
